export default {
  data() {
    return {
      img: require('@/assets/images/service/sailing-version/sailing-version-qs.png')
    };
  }
};